var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "add_shopping_cart"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_7427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_7427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_shopping_cart_2",
    d: "M14.5625 10.4375V6.6875H10.8125V5.8125H14.5625V2.0625H15.4375V5.8125H19.1875V6.6875H15.4375V10.4375H14.5625ZM9.25 26.0625C8.77083 26.0625 8.36979 25.901 8.04688 25.5781C7.72396 25.2552 7.5625 24.8542 7.5625 24.375C7.5625 23.8958 7.72396 23.4948 8.04688 23.1719C8.36979 22.849 8.77083 22.6875 9.25 22.6875C9.72917 22.6875 10.1302 22.849 10.4531 23.1719C10.776 23.4948 10.9375 23.8958 10.9375 24.375C10.9375 24.8542 10.776 25.2552 10.4531 25.5781C10.1302 25.901 9.72917 26.0625 9.25 26.0625ZM20.75 26.0625C20.2708 26.0625 19.8698 25.901 19.5469 25.5781C19.224 25.2552 19.0625 24.8542 19.0625 24.375C19.0625 23.8958 19.224 23.4948 19.5469 23.1719C19.8698 22.849 20.2708 22.6875 20.75 22.6875C21.2292 22.6875 21.6302 22.849 21.9531 23.1719C22.276 23.4948 22.4375 23.8958 22.4375 24.375C22.4375 24.8542 22.276 25.2552 21.9531 25.5781C21.6302 25.901 21.2292 26.0625 20.75 26.0625ZM2.875 4.1875V3.3125H5.625L10.6875 13.9375H18.8438C19.0312 13.9375 19.1979 13.8906 19.3438 13.7969C19.4896 13.7031 19.6146 13.5729 19.7188 13.4062L23.9375 5.8125H24.9375L20.4375 13.9375C20.2708 14.2083 20.0569 14.4219 19.7956 14.5781C19.5343 14.7344 19.2482 14.8125 18.9375 14.8125H10.125L8.5625 17.6875C8.39583 17.9375 8.39062 18.2083 8.54688 18.5C8.70312 18.7917 8.9375 18.9375 9.25 18.9375H22.4375V19.8125H9.25C8.58333 19.8125 8.08854 19.5365 7.76562 18.9844C7.44271 18.4323 7.4375 17.875 7.75 17.3125L9.6875 13.875L5.0625 4.1875H2.875Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantManagement);
export default __webpack_public_path__ + "static/media/merchant-management.f2c851b4.svg";
export { ForwardRef as ReactComponent };